import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  quizTitle: {
    fontSize: '32px !important'
  },
  questionAnswerWrapper: {
    minWidth: 520,
    width: '100%'
  }
}))
